<template>
  <aside
    class="oct-snackbar"
    @click="close"
    v-show="this.isOpen"
  >
    <div class="oct-snackbar__surface" role="status" aria-relevant="additions">
      <div class="oct-snackbar__label" aria-atomic="false">
        {{ text }}
      </div>
      <div class="oct-snackbar__actions" aria-atomic="true">
        <oct-icon-button
          size="minimum"
          icon="close"
          class="oct-snackbar__action"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import OctIconButton from '@/components/icon-button/OctIconButton.vue';

export default {
  components: { OctIconButton },
  name: 'OctSnackbar',
  props: {
    /** Duration to close in miliseconds */
    duration: {
      type: Number,
      default: 3000
    },
  },
  data () {
    return {
      /** Display text */
      text: '',
      /** Open? */
      isOpen: false,
      /** Snackbar stacks */
      $_osb_texts: [],
      /** Timeout id */
      $_osb_tid: null
    }
  },
  methods: {
    /** Open snackbar */
    async open (val='') {
      // Add textt to stack
      val && this.$data.$_osb_texts.push(val)

      // Wait for close
      if (this.isOpen)
        return this.close()

      // Dequeue text
      this.text = this.$data.$_osb_texts.shift()

      // Do open
      this.isOpen = true

      // Wait for reflow
      await this.$nextTick()
      this.$el.clientHeight

      this.$el.classList.add('oct-snackbar--open')

      // Clear timeout
      clearTimeout(this.$data.$_osb_tid)

      // Close after duration
      this.$data.$_osb_tid = setTimeout(() => {
        this.close()
      }, this.duration)
    },
    /** Close snackbar */
    async close () {
      // Clear timeout
      clearTimeout(this.$data.$_osb_tid)

      // Do close
      this.$el.classList.remove('oct-snackbar--open')

      this.$data.$_osb_tid = setTimeout(() => {
        this.isOpen = false
        // Continue
        this.$data.$_osb_texts.length && this.open()
      }, 500)
    }
  },
  mounted () {
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-snackbar {
  position: fixed;
  top: oct-rem(20);
  right: oct-rem(0);
  z-index: 100;
}

.oct-snackbar__surface {
  display: flex;
  align-items: center;
  padding: oct-rem(20) oct-rem(12) oct-rem(20) oct-rem(16);
  background-color: $oct-theme--on-primary;
  border-radius: oct-rem(12);
  transform: translateX(100%);
  transition-duration: .4s;

  .oct-snackbar--open & {
    margin: 0 oct-rem(20) 0 0;
    transform: translateX(0);
  }
}

.oct-snackbar__label {
  font-size: oct-rem(17);
  line-height: (24/17);
  letter-spacing: 0;
  white-space: nowrap;
  margin: 0 oct-rem(12) 0 0;
  flex: 0 0 auto;
  min-width: oct-rem(136);
}

.oct-snackbar__actions {
  flex: 0 0 auto;
}
</style>